<!-- Zweck: Stellt die HTML-Struktur für app page loader component im Frontend bereit. -->
<!--<div class="loaderbox" *ngIf="isLoading">
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>-->

@if (offline || apioffline || hasText) {
  <div class="fullscreenloader">
    <div class="inner">
      <div class="logo">
        <img src="assets/images/logos/default.png"/>
      </div>
      @if (apioffline && !offline && !hasText) {
        <div class="text">
          Server <br> derzeit nicht erreichbar
        </div>
      }
      @if (offline && !hasText) {
        <div class="text">
          Derzeit offline. <br> Bitte Internetverbindung prüfen!
        </div>
      }
      @if (hasText && loading_title) {
        <div class="text">
          {{loading_title}}
        </div>
      }
      <br>
        <div class="loading">
          @if (hasText && loading_text) {
            <span>
              {{loading_text}}
            </span>
          }
          @if (!hasText || !loading_text) {
            <span>
              Warte
            </span>
          }
          <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
        </div>
      </div>
    </div>
  }
